module.exports = __webpack_public_path__ + "static/media/uk.934852d7.png";